// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"f0ccc1e2","453":"f1966be5"}[chunkId] + ".chunk.js";
};